module.exports = __webpack_public_path__ + "img/49.a16df98c.jpg";